/**
 * Appels aux routes BlueNote Pocket du backend (/api/pocket), avec l'authentification BlueNote.
 */
import axios from 'axios';

const authHeaders = () => ({ Authorization: `Bearer ${sessionStorage.getItem('authToken')}` });

export const previewPocketFile = async (reportId, fileContent, secret) => {
  const { data } = await axios.post(`/api/pocket/reports/${reportId}/preview`, { fileContent, secret }, { headers: authHeaders() });
  return data;
};

export const importPocketFile = async (reportId, payload) => {
  const { data } = await axios.post(`/api/pocket/reports/${reportId}/import`, payload, { headers: authHeaders() });
  return data;
};

export const saveWorkingAnswers = async (reportId, rubricId, workingAnswers) => {
  const { data } = await axios.put(
    `/api/pocket/reports/${reportId}/rubrics/${encodeURIComponent(rubricId)}/working-answers`,
    { workingAnswers },
    { headers: authHeaders() }
  );
  return data.workingAnswers;
};

export const fetchLinkTargets = async (code, definitionVersion) => {
  const { data } = await axios.get('/api/pocket/link-targets', { params: { code, definitionVersion }, headers: authHeaders() });
  return data;
};

export const linkPocketRubric = async (reportId, rubricId, version) => {
  const { data } = await axios.post(
    `/api/pocket/reports/${reportId}/rubrics/${encodeURIComponent(rubricId)}/link`,
    { version },
    { headers: authHeaders() }
  );
  return data;
};

export const convertPocketRubric = async (reportId, rubricId) => {
  const { data } = await axios.post(
    `/api/pocket/reports/${reportId}/rubrics/${encodeURIComponent(rubricId)}/convert-free-text`,
    {},
    { headers: authHeaders() }
  );
  return data;
};

/** Message lisible d'une erreur renvoyée par les routes Pocket (jamais de détail technique). */
export const pocketErrorMessage = (error, fallback) => {
  const message = error && error.response && error.response.data && error.response.data.message;
  return typeof message === 'string' && message.length > 0 ? message : fallback;
};

/** Identifiant d'import (clé d'idempotence) généré côté client. */
export const newImportId = () => {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
